import React from 'react';
import { ProductHistoryPreviewTemplate } from 'themes/application/product/pages';
import { observer } from 'mobx-react';
import { ProductHistoryPreviewViewStore } from 'application/product/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore) => new ProductHistoryPreviewViewStore(rootStore), 'productHistoryPreviewViewStore')
@observer
class ProductHistoryPreview extends React.Component {
    render() {
        return <ProductHistoryPreviewTemplate {...this.props} />
    }
}

export default ProductHistoryPreview;